export default "__VITE_ASSET__BCANainz__"